// @ts-strict-ignore
import React from 'react';

import { Box } from 'components/Box';
import { Flex } from 'components/Flex';
import { LegacyInputField, SelectField } from 'components/Form';
import { COUNTRIES, US_STATES } from 'utils/constants';

export function AddressWithoutLocationForm({
  namePrefix,
  useUSStateDropdown,
}: {
  namePrefix?: string;
  useUSStateDropdown?: boolean;
}) {
  const getName = (name) => (namePrefix ? `${namePrefix}.${name}` : name);

  return (
    <>
      <SelectField
        name={getName('country')}
        label={
          /* TRANSLATORS: Form field for address country */
          `${getText('Country')}*`
        }
        options={COUNTRIES.map(({ id, name }) => ({
          label: name,
          value: id,
        }))}
      />

      <LegacyInputField
        name={getName('line1')}
        label={
          /* TRANSLATORS: Form field for address line 1 */
          `${getText('Address Line 1')}*`
        }
        placeholder={getText('123 5th Street')}
      />

      <LegacyInputField
        name={getName('line2')}
        label={
          /* TRANSLATORS: Form field for address line 2 */
          getText('Address Line 2')
        }
        placeholder={getText('e.g., suite 201 (optional)')}
      />

      <LegacyInputField
        name={getName('city')}
        label={
          /* TRANSLATORS: Form field for address city */
          `${getText('City')}*`
        }
        placeholder={getText('Lake Wobegon')}
      />

      <Flex flexWrap={['wrap', 'wrap', 'wrap', 'nowrap']}>
        {useUSStateDropdown ? (
          <SelectField
            label={
              /* TRANSLATORS: US State */
              `${getText('State')}*`
            }
            name="state"
            options={[
              {
                value: '',
                label: 'Select One',
                disabled: true,
              },
            ].concat(
              // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
              US_STATES.map((state) => ({
                label: state.name,
                value: state.id,
              }))
            )}
          />
        ) : (
          <Box width={1} pr={[0, 0, 0, '8px']}>
            <LegacyInputField
              name={getName('state')}
              label={
                /* TRANSLATORS: Form field for address state/province */
                `${getText('State/Province')}*`
              }
              placeholder={getText('Minnesota')}
            />
          </Box>
        )}

        <Box width={1} pl={[0, 0, 0, '8px']}>
          <LegacyInputField
            name={getName('zipcode')}
            label={
              /* TRANSLATORS: Form field for address zip/postal code */
              `${getText('Zip/Postal Code')}*`
            }
            placeholder={getText('12345')}
          />
        </Box>
      </Flex>
    </>
  );
}
